import { render } from "./ConfirmDialogue.vue?vue&type=template&id=66d972a5&scoped=true"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=66d972a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d972a5"]])

export default __exports__